module.exports = __webpack_public_path__ + "static/media/7_r_kover_65.42_89.72.ccb39971.png";